export function detectBrowser(userAgent: string): string {
  if (/Edg\//.test(userAgent)) {
    const match = new RegExp(/Edg\/([\d.]+)/).exec(userAgent);
    return `Edge ${match?.[1] ?? ''}`.trim();
  }
  if (/Chrome\//.test(userAgent)) {
    const match = new RegExp(/Chrome\/([\d.]+)/).exec(userAgent);
    return `Chrome ${match?.[1] ?? ''}`.trim();
  }
  if (/Firefox\//.test(userAgent)) {
    const match = new RegExp(/Firefox\/([\d.]+)/).exec(userAgent);
    return `Firefox ${match?.[1] ?? ''}`.trim();
  }
  if (/Safari\//.test(userAgent) && !/Chrome/.test(userAgent)) {
    const match = new RegExp(/Version\/([\d.]+)/).exec(userAgent);
    return `Safari ${match?.[1] ?? ''}`.trim();
  }
  return '[Unknown browser]';
}
